<template>
  <div>
    <div class="text-center bg-light-green p-3 my-2">
      <span
        class="profile-picture-avatar"
      >
        <b-avatar
          size="128"
          class="mb-2"
          :src="blobs[0]"
        />
        <span
          v-if="$attrs.disabled!==true&&imageId"
          class="trash-icon"
          @click="removePicture"
        >
          <feather-icon
            icon="TrashIcon"
            size="24"
          />
        </span>
      </span>

      <template v-if="!$attrs.disabled">
        <!-- Image Uploader -->
        <files-uploader
          :label="$attrs.label"
          :file-type="$attrs['file-type']"
          :accept="accept"
          :rules="rules"
          :cropper="$attrs.cropper"
          :stencil-props="$attrs['stencil-props']"
          @update:files="setProfilePicture"
        />
        <p class="text-dark">
          {{ $attrs.description }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import createBlobs from '@/compositions/common/createBlobs'
import Files from '@/compositions/Files/FilesAPI'
import handleAlerts from '@/compositions/common/handleAlerts'
import FilesUploader from './FilesUploader.vue'

export default {
  name: 'ProfilePictureUploader',
  components: {
    FilesUploader,
  },
  props: {
    accept: { type: String, default: '' },
    rules: { type: [String, Object], default: '' },
    image: { type: Object, default: () => ({}) },
  },
  computed: {
    imageProxy: {
      get() {
        return this.image
      },
      set(value) {
        return this.$emit('update:image', value)
      },
    },
    imageId() {
      return this.image?.id
    },
  },
  setup() {
    const { confirmOperation, successfulDeletionAlert } = handleAlerts()
    const { deleteFileRequest } = Files()
    const { blobs, convertFilesToBlob, clearBlobs } = createBlobs()
    return {
      blobs, confirmOperation, successfulDeletionAlert, convertFilesToBlob, clearBlobs, deleteFileRequest,
    }
  },
  mounted() {
    this.convertFilesToBlob([this.image])
  },
  beforeDestroy() {
    this.clearBlobs()
  },
  methods: {
    setProfilePicture(files) {
      [this.imageProxy] = files
      this.convertFilesToBlob(files)
    },
    removePicture() {
      this.confirmOperation('Are you sure you want to delete this image?').then(() => {
        this.deleteFileRequest(this.image.id).then(() => {
          this.successfulDeletionAlert('Image is deleted successfully')
          this.clearBlobs()
          this.$emit('update:imageId', null)
          this.imageProxy = {}
        })
      })
    },
  },
}
</script>

<style lang="scss">
.profile-picture-avatar {
  position: relative;
  .trash-icon {
    position:absolute;
    bottom: -1.5em;
    right: 1.3em;
    color:var(--primary);
    visibility: hidden;
    padding: 2em;
    border-radius: 50%;
    cursor: pointer;
  }
  &:hover .trash-icon {
    background-color: #ffffffe8;
    visibility: visible;
  }
}
</style>
